import { render, staticRenderFns } from "./AsetFilters.vue?vue&type=template&id=2dc4d682&"
import script from "./AsetFilters.vue?vue&type=script&lang=js&"
export * from "./AsetFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports